<template>
  <b-container>
    <!-- Elementos de la tabla -->
    <div class="table-responsive">
      <h3>{{ $t("servicios.formularioBultos.bultos") }}</h3>

      <v-data-table
        :headers="headers"
        :items="Bultos"
        class="elevation-1"
        hide-actions
      >
        <template v-slot:items="props">
          <td class="text-xs-center">
            <v-select
              :items="contenidos"
              v-model="props.item.Contenido"
              item-text="text"
              item-value="value"
            ></v-select>
          </td>
          <td class="text-xs-center">
            <vue-numeric-input
              min="0"
              controls-type="updown"
              size="70px"
              precision="2"
              v-model="props.item.Peso"
            ></vue-numeric-input>
          </td>
          <td class="text-xs-center">
            <vue-numeric-input
              min="0"
              controls-type="updown"
              size="70px"
              precision="2"
              v-model="props.item.Alto"
            ></vue-numeric-input>
          </td>
          <td class="text-xs-center">
            <vue-numeric-input
              min="0"
              controls-type="updown"
              size="70px"
              precision="2"
              v-model="props.item.Ancho"
            ></vue-numeric-input>
          </td>
          <td class="text-xs-center">
            <vue-numeric-input
              min="0"
              controls-type="updown"
              size="70px"
              precision="2"
              v-model="props.item.Largo"
            ></vue-numeric-input>
          </td>
          <td class="text-xs-center">
            <v-text-field v-model="props.item.Observacion"></v-text-field>
          </td>
          <td class="text-xs-center">
            <v-text-field v-model="props.item.Referencia"></v-text-field>
          </td>
          <td class="text-xs-center">
            <b-button
              size="sm"
              @click.stop="deleteEvent(props.index)"
              class="mr-1"
              variant="danger"
              >X</b-button
            >
          </td>
        </template>
      </v-data-table>
    </div>

    <div class="text-xs-right">
      <v-btn small dark color="primary" @click="modalShow = true">
        {{ $t("servicios.formularioBultos.añadirBulto") }}
        <v-icon dark>add</v-icon>
      </v-btn>
    </div>
    <b-modal id="modalBultos" centered hide-footer v-model="modalShow" title="Añadir bultos">
      <div class="d-flex text-center">
        <b-form-group label="Número de bultos">
          <b-form-input v-model="numBultos" id="type-number" type="number"></b-form-input>
        </b-form-group>
        <b-form-group label="Peso total">
          <b-form-input v-model="pesoTotal" id="type-number" type="number"></b-form-input>
        </b-form-group>
      </div>
      <div class="mt-2">
        <v-btn block dark slot="activator" color="primary" @click="addNewPackage()">
          Añadir
        </v-btn>
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { mapActions, mapState, mapGetters } from "vuex";
import VueNumericInput from "vue-numeric-input";

export default {
  mixins: [validationMixin],
  mounted() {
    if (this.Bultos.length === 0) this.addNewPackage();
  },
  props: {
    Bultos: {
      type: Array,
      required: true,
    },
    puedoEditar: {
      type: Boolean,
      required: true,
      default: true,
    },
  },
  data() {
    return {
      contenidos: [
        {
          text: "Documento",
          value: "DOC",
        },
        {
          text: "Factura",
          value: "FAC",
        },
        {
          text: "Paquete",
          value: "PAQ",
        },
      ],
      headers: [
        { text: "Contenido", value: "Contenido", sortable: false },
        { text: "Peso (Kgs)", value: "Peso", sortable: false },
        { text: "Alto (Cm)", value: "Alto", sortable: false },
        { text: "Ancho(Cm)", value: "Ancho", sortable: false },
        { text: "Largo(Cm)", value: "Largo", sortable: false },
        { text: "Observacion", value: "Observacion", sortable: false },
        { text: "Referencia", value: "Referencia", sortable: false },
        { text: "Eliminar", value: "actions", sortable: false },
      ],
      fields: [
        { key: "number", label: "#", sortable: true, sortDirection: "desc" },
        {
          key: "Contenido",
          label: "Contenido",
          sortable: true,
          sortDirection: "desc",
          class: "w-25",
        },
        {
          key: "Peso",
          label: "Peso (Kgs)",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "Alto",
          label: "Alto (Cm)",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "Ancho",
          label: "Ancho (Cm)",
          sortable: false,
          sortDirection: "desc",
        },
        {
          key: "Largo",
          label: "Largo (Cm)",
          sortable: true,
          sortDirection: "desc",
        },
        { key: "Observacion", label: "Observaciones" },
        { key: "Referencia", label: "Referencia" },
        { key: "actions", label: "Eliminar" },
      ],
      numBultos: 1,
      pesoTotal: 0,
      modalShow: false
    };
  },
  methods: {
    /*format(value, event) {
        let resp = value.replace(/[^0-9]/g,'');
        if(resp === 0) resp = 1;
        return resp;
    },*/
    validateBeforeSubmit() {
      this.$emit("processExpedition", this.expedition);
    },
    ...mapActions("servicesTypes", ["fetchServicesTypes"]),
    addNewPackage() {
      this.modalShow = false;
      //$bvModal.show('modalBultos')
      let pesoUnitario = this.pesoTotal / this.numBultos;
      let item = {
        Id: null,
        Numero: this.Bultos.length + 1,
        Contenido: "PAQ",
        Peso: pesoUnitario,
        Alto: 1,
        Ancho: 1,
        Largo: 1,
        Observacion: "",
        Referencia: "",
      };
      for (let index = 0; index < this.numBultos; index++) {
        this.Bultos.push(item);
      }
      this.pesoTotal = 0;
      this.numBultos = 1;
      try {
        this.$parent.servicio.NumBultos = this.Bultos.length;
        this.$parent.servicio.PesoTotal = this.total();
      } catch (error) {}
    },
    total: function () {
      let sum = 0;
      return this.Bultos.reduce((sum, item) => sum + item.Peso, 0);
    },
    deleteEvent: function (index) {
      if (this.Bultos.length === 1) return;
      this.Bultos.splice(index, 1);
      try {
        this.$parent.servicio.NumBultos = this.Bultos.length;
        this.$parent.servicio.PesoTotal = this.total();
      } catch (error) {}
    },
    actualizarPeso() {
      this.$parent.servicio.PesoTotal = this.total();
    },
    checkDecimalesPeso(item) {
      item.Peso = item.Peso.toFixed(2);
    },
    formatterDecimales(value, event) {
      value += "";
      var split = value.split(".");
      if (split.length < 2) return value;
      if (split[1].length > 1) {
        let temp = split[0] + "." + split[1][0] + split[1][1];
        return temp;
      }
      return value;
    },
    test(props) {
      console.log(JSON.stringify(props));
    },
  },
};
</script>

<style>
.center {
  width: 500px;
  margin: 24px auto 44px auto !important;
}
h2 {
  text-align: center;
}

table caption {
  padding: 0.5em 0;
}

@media screen and (max-width: 767px) {
  table caption {
    border-bottom: 1px solid #ddd;
  }
  input[type="number"] {
    width: px;
  }
}
</style>

